import { render, staticRenderFns } from "./JobCategoryIcon.vue?vue&type=template&id=31a8e7cc"
import script from "./JobCategoryIcon.vue?vue&type=script&lang=js"
export * from "./JobCategoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports